import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { AccessToken, checkedFetchAccessTokenIfNeeded, State } from '~/AccessToken';
import { ModuleType } from '~/Api/User/ProductGroup';

import NavigationMenu, { Access } from './NavigationMenu';

const selectAccess = memoizeOne((accessToken: AccessToken | null): Access | null => {
	if (accessToken === null || accessToken.subscription === null) {
		return null;
	}

	const { systemModules } = accessToken.subscription;
	return {
		irp: systemModules.has('erp'),
		analytics: systemModules.has('analytics'),
		search: systemModules.has('search-app'),
		productGroups: systemModules.has('product-groups'),
		availability: systemModules.has(ModuleType.czReimbursement),
	};
});

function mapStateToProps({ accessToken }: { accessToken: State }): {
	access: Access | null;
} {
	return {
		access: selectAccess(accessToken.accessToken),
	};
}

const actions = {
	onFetch: checkedFetchAccessTokenIfNeeded,
};

export default connect(mapStateToProps, actions)(NavigationMenu);
